<script lang="ts" setup>
defineProps({
  width: {
    type: String,
    default: '24',
  },
});
</script>

<template>
  <svg
    :width="width"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g>
      <path
        d="M14.27 6.00001C13.72 6.95001 14.05 8.18001 15 8.73001C15.95 9.28001 17.18 8.95001 17.73 8.00001C18.28 7.05001 17.95 5.82001 17 5.27001C16.05 4.72001 14.82 5.05001 14.27 6.00001Z"
        fill="currentColor"
      />
      <path
        d="M15.84 10.41C15.84 10.41 14.21 9.47001 13.24 8.91001C10.86 7.53001 10.04 4.47001 11.42 2.09001L9.69001 1.09001C8.10001 3.83001 8.60001 7.21001 10.66 9.40001L5.51001 18.32L7.24001 19.32L8.74001 16.72L10.47 17.72L7.47001 22.92L9.20001 23.92L15.49 13.03C16.63 14.58 16.82 16.72 15.8 18.49L17.53 19.49C19.13 16.74 18.81 12.91 15.84 10.41Z"
        fill="currentColor"
      />
      <path
        d="M12.75 3.80001C13.47 4.21001 14.38 3.97001 14.8 3.25001C15.21 2.53001 14.97 1.62001 14.25 1.20001C13.53 0.790006 12.62 1.03001 12.2 1.75001C11.79 2.47001 12.03 3.39001 12.75 3.80001Z"
        fill="currentColor"
      />
    </g>
  </svg>
</template>
